import { apiClient } from '../lib/apiClient';
import type { AiSuggestion, SuggestionReasoning } from '../types/aiSuggestion';

export interface SuggestionListResponse {
  data: AiSuggestion[];
}

export interface AcceptSuggestionResponse {
  data: AiSuggestion;
}

export interface DismissSuggestionResponse {
  data: AiSuggestion;
}

export interface EditAndAcceptSuggestionResponse {
  data: AiSuggestion;
}

export interface SuggestionReasoningResponse {
  data: SuggestionReasoning;
}

export async function listSuggestions(aquariumId: string): Promise<SuggestionListResponse> {
  return apiClient.get<SuggestionListResponse>(
    `/api/v1/aquariums/${aquariumId}/ai-suggestions`,
  );
}

export async function acceptSuggestion(suggestionId: string): Promise<AcceptSuggestionResponse> {
  return apiClient.post<AcceptSuggestionResponse>(
    `/api/v1/ai-suggestions/${suggestionId}/accept`,
    {},
  );
}

export async function dismissSuggestion(suggestionId: string): Promise<DismissSuggestionResponse> {
  return apiClient.post<DismissSuggestionResponse>(
    `/api/v1/ai-suggestions/${suggestionId}/dismiss`,
    {},
  );
}

export async function editAndAcceptSuggestion(
  suggestionId: string,
  // Mirrors the backend EditAcceptBodySchema (src/validators/aiSuggestion.ts):
  // `amount`/`frequency` are the edited dose (#1383), bounded server-side.
  edits: {
    title?: string;
    description?: string;
    priority?: string;
    due_date?: string | null;
    amount?: number;
    frequency?: string;
  },
): Promise<EditAndAcceptSuggestionResponse> {
  return apiClient.post<EditAndAcceptSuggestionResponse>(
    `/api/v1/ai-suggestions/${suggestionId}/edit-accept`,
    edits,
  );
}

export async function getSuggestionReasoning(
  suggestionId: string,
): Promise<SuggestionReasoningResponse> {
  return apiClient.get<SuggestionReasoningResponse>(
    `/api/v1/ai-suggestions/${suggestionId}/reasoning`,
  );
}
